export const GET_LECTIONS = 'getLections';
export const GET_LECTION = 'getLection';
